export type ContactsTab = 'groups' | 'events';

/** Sentinel for pinned «همه مخاطبان» — not a real contact group. */
export const ALL_CONTACTS_GROUP_ID = '__all__' as const;

export type ContactGroupId = string;

export type ContactHeaderMenuAction =
  | 'export'
  | 'editGroup'
  | 'deleteGroup'
  | 'editEvent'
  | 'deleteEvent';

export type EventType = 'shared' | 'individual';

export type ContactRowAction =
  | 'view'
  | 'moveToGroup'
  | 'setEventDate'
  | 'export'
  | 'editGroup'
  | 'deleteGroup'
  | 'delete';

export type ContactImportMethod = 'manual' | 'file';

export type ContactImportStep =
  | 'method'
  | 'input'
  | 'column-map'
  | 'preview'
  | 'done';

export type ContactFileKind = 'text' | 'excel';

export interface ContactGroup {
  id: string;
  name: string;
  contactsCount: number;
}

export interface ContactGroupListItem {
  id: ContactGroupId;
  name: string;
  contactsCount: number;
  isSystem?: boolean;
}

export interface ContactEvent {
  id: string;
  name: string;
  usedCount?: number;
  type: EventType;
  eventDate?: string | null;
}

export interface CreateContactEventPayload {
  name: string;
  type: EventType;
  eventDate?: string | null;
}

export interface UpdateContactEventPayload extends CreateContactEventPayload {
  id: string;
}

export interface EventMembersListQuery {
  eventId: string;
  phrase?: string;
  page?: number;
  pageSize?: number;
}

export interface Contact {
  id: string;
  firstName: string;
  lastName: string;
  mobile: string;
  email?: string;
  address?: string;
  isMale?: boolean | null;
  groups: string[];
  events: string[];
  eventIds: string[];
  /** Individual-event member date (Jalali string), when set for the active event. */
  memberEventDate?: string | null;
  createdAt: string;
  customFields?: Record<string, string>;
}

export interface ContactGroupListQuery {
  phrase?: string;
  page?: number;
  pageSize?: number;
}

export interface ContactGroupListResult {
  items: ContactGroup[];
  total: number;
}

export interface ContactsListQuery {
  groupId: string;
  phrase?: string;
  page?: number;
  pageSize?: number;
  groupName?: string;
}

export interface ContactsListResult {
  items: Contact[];
  total: number;
}

export interface CreateContactGroupPayload {
  name: string;
}

export interface UpdateContactPayload {
  firstName?: string;
  lastName?: string;
  mobile?: string;
  email?: string;
  address?: string | null;
  isMale?: boolean | null;
  userEvents?: {userEventId: number; raiseDateTime: number}[];
}

export interface DeleteContactPayload {
  contactId: string;
  groupId: string;
  deleteGlobally: boolean;
}

export interface BulkPreviewResult {
  wrongNumber: number;
  totalCount: number;
  systemScopeExistsContactCount: number;
  groupScopeExistsContactCount: number;
  addCount: number;
  key: string;
  distinctCount?: number;
}

export interface ExcelFirstStepResult {
  key: string;
  columnTitles: string[];
}

export interface ExcelColumnMapping {
  [excelColumnTitle: string]: string | number;
}

export interface AddContactModalData {
  defaultGroupId: string;
  defaultGroupName?: string;
}

export interface ContactDeleteModalData {
  contactName: string;
  contactMobile?: string;
  groupId?: string;
  eventId?: string;
  context?: 'group' | 'event';
  bulkCount?: number;
}

export interface ContactDetailsDrawerData {
  contactId: string;
  groupId: string;
  position?: 'bottom' | 'left' | 'right' | 'top';
}

export type ContactDrawerTab = 'general' | 'history';

export interface ContactHistoryEntry {
  id: string;
  activity: string;
  date: string;
}

export function contactDisplayName(contact: Contact): string {
  return `${contact.firstName} ${contact.lastName}`.trim();
}
